// o boot "chatwoot" faz o uso deste path, caso atualize, alterar lá.
export default [
  {
    path: 'customers/new',
    name: 'ExternalCustomersCreate',
    component: () => import('pages/external/customers-create/ExternalCustomersCreate.vue')
  },
  {
    path: 'customers/registered',
    name: 'ExternalCustomersRegistered',
    component: () => import('pages/external/customers-registered/ExternalCustomersRegistered.vue')
  }
]
